module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M02-clean-160e412bb78cc59f47aec17fb4b4347d.png";